import { mapObjIndexed } from 'ramda';
import { type FiltersSelection } from '../types';
import { createRoomsParticipantDistributionMapper } from './mappers/roomsParticipantDistributionMapper';
import { priceRangeMapper } from './mappers/priceRangeMapper';

type SelectionMappers<F> = Partial<{
  [K in keyof F]: (value: FiltersSelection<F>[K]) => unknown;
}>;

interface Dependencies<F> {
  mappers: SelectionMappers<F>;
}

export interface FiltersSelectionMapper<F> {
  map: (filterSelection: FiltersSelection<F>) => Record<string, unknown>;
}

const defaultMappers = {
  PricePerPerson: priceRangeMapper,
  Participants: createRoomsParticipantDistributionMapper(),
};

export const createFiltersSelectionMapper = <F>(
  dependencies: Partial<Dependencies<F>> = {}
): FiltersSelectionMapper<F> => {
  const { mappers = defaultMappers as SelectionMappers<F> } = dependencies as Dependencies<F>;

  const mapFilterValue = <K extends keyof F>(value: FiltersSelection<F>[K], filterKey: string) =>
    mappers[filterKey as keyof F]?.(value) ?? value;

  const map = (filterSelection: FiltersSelection<F>) => mapObjIndexed(mapFilterValue, filterSelection);

  return { map };
};
